import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13f2f470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash-alt",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-print",
  _mstvisible: "2"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus",
  _mstvisible: "2"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_9 = { class: "general" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Detalles de Recepción")
], -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = { class: "form-floating" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "no" }, "No.:", -1))
const _hoisted_16 = { class: "form-floating" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rncEmisor" }, "Fecha:", -1))
const _hoisted_18 = { class: "form-floating" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tipo" }, "Médico:", -1))
const _hoisted_20 = { class: "form-floating" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Médico", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Secretaria", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Otro", -1))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tipo" }, "Entregado Por:", -1))
const _hoisted_26 = { class: "form-floating" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recibidoPor" }, "Recibido Por:", -1))
const _hoisted_28 = { class: "form-floating" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lugar" }, "Lugar:", -1))
const _hoisted_30 = { class: "form-floating" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lugar" }, "Cantidad:", -1))
const _hoisted_32 = { class: "form-floating" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "observaciones" }, "Observaciones:", -1))
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDelete())),
          class: "a red",
          to: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push(`/recepcions2/${this.$route.params.id}`))),
          class: "a orange",
          to: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/recepcions"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "a green",
          to: "/recepcions/new"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "no",
                  type: "no",
                  placeholder: "No.",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentRecepcion.no) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentRecepcion.no]
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  id: "fecha",
                  type: "datetime-local",
                  placeholder: "Fecha",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentRecepcion.fecha) = $event)),
                  class: "form-control",
                  autofocus: ""
                }, null, 512), [
                  [_vModelText, _ctx.currentRecepcion.fecha]
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  id: "medico",
                  type: "medico",
                  placeholder: "Médico",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentRecepcion.medico) = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicos, (medico, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(medico.emisor), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.currentRecepcion.medico]
                ]),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("select", {
                  id: "tipo",
                  type: "tipo",
                  placeholder: "Tipo",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentRecepcion.entregadoPor) = $event)),
                  class: "form-select"
                }, _hoisted_24, 512), [
                  [_vModelSelect, _ctx.currentRecepcion.entregadoPor]
                ]),
                _hoisted_25
              ]),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  id: "recibidoPor",
                  type: "recibidoPor",
                  placeholder: "recibidoPor",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentRecepcion.recibidoPor) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentRecepcion.recibidoPor]
                ]),
                _hoisted_27
              ]),
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  id: "lugar",
                  type: "lugar",
                  placeholder: "lugar",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentRecepcion.lugar) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentRecepcion.lugar]
                ]),
                _hoisted_29
              ]),
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  id: "cantidad",
                  type: "number",
                  step: "1",
                  placeholder: "cantidad",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentRecepcion.cantidad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentRecepcion.cantidad]
                ]),
                _hoisted_31
              ]),
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  id: "observaciones",
                  type: "observaciones",
                  placeholder: "observaciones",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentRecepcion.observaciones) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentRecepcion.observaciones]
                ]),
                _hoisted_33
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
            disabled: 
            !_ctx.currentRecepcion.fecha ||
            !_ctx.currentRecepcion.medico ||
            !_ctx.currentRecepcion.entregadoPor ||
            !_ctx.currentRecepcion.recibidoPor ||
            !_ctx.currentRecepcion.lugar ||
            !_ctx.currentRecepcion.cantidad
      
          }, "Actualizar ", 8, _hoisted_34)
        ])
      ])
    ])
  ], 64))
}